import { CoreTagsIdMapName } from './name';
import { createUpdateSyncSlice } from '@sonar-software/xuder';
import { defaultTagsIdMapState } from './state';
import { UpdateSonarTagReferenceRequest } from '@types';

export const coreTagsIdMapSlice = createUpdateSyncSlice({
	name: CoreTagsIdMapName,
	state: defaultTagsIdMapState,
	transform: (action: Array<UpdateSonarTagReferenceRequest>, state = {}) => {
		if (!action.length) {
			return state;
		}

		const updatedState: typeof state = {
			...state
		};

		for (const entry of action) {
			const existingEntry = state[ entry.id ] ?? {};

			updatedState[ entry.id ] = {
				...existingEntry,
				...entry
			};
		}

		return updatedState;
	}
});
